module.exports = __webpack_public_path__ + "067326a9207a58073e695103c9687c28.pdf";